/**
 * Webpack require.context registrations for category image folders.
 * Add one line here when a new category folder is introduced under assets/images.
 */

export const categoryImageContexts = {
  wedding: require.context(
    "../assets/images/Wedding Event/Wedding Event",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  corporate: require.context(
    "../assets/images/Corporate Event/Corporate Event",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  social: require.context(
    "../assets/images/Social Event/Social Event",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  other: require.context(
    "../assets/images/Other Event/Other Event",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  concert: require.context(
    "../assets/images/Concert/Concert",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  production: require.context(
    "../assets/images/Production/Production",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  blogs: require.context(
    "../assets/images/Blog/Blog",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
  /** /events hub — dedicated folder may replace this path later */
  eventsHub: require.context(
    "../assets/images/Social Event/Social Event",
    false,
    /\.(webp|png|jpe?g|gif)$/i,
  ),
};
